export default __webpack_public_path__ + "static/media/ledger-logo.7a656384.svg";